import { render, staticRenderFns } from "./GoodPhoto.vue?vue&type=template&id=43022313&scoped=true"
import script from "./GoodPhoto.vue?vue&type=script&lang=js"
export * from "./GoodPhoto.vue?vue&type=script&lang=js"
import style0 from "./GoodPhoto.vue?vue&type=style&index=0&id=43022313&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43022313",
  null
  
)

export default component.exports